/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/
import Input from '../../components/formComponents/input';
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';


/*Assets*/
import logo from '../../assets/images/logo.svg';
import loginHero from '../../assets/images/login-hero.svg';
import Toast from '../../components/toast/toast.js';
import GetURLVar from '../../services/getParams/get-url-var';

class AdminLogin extends Component {
  constructor(props){
    super(props);
    this.state = {
      username: "",
      password: "",
      error: "",
      apiLoading: false
    }
  }

  componentDidMount() {
    GetURLVar().then(function(query){
      if(query.vendor && query.token){
        this.adminLogin(query.vendor, query.token);
      }
      if(query.type&&query.type=="local"){
        localStorage.setItem("vendor_data", JSON.stringify({seller_type: 4}));
      }
    }.bind(this));
  }

  adminLogin(id, token){
    localStorage.setItem("vendor_token", token);
    this.getData();
  }

  getData(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'auth/profile';
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        this.setState({ 
         apiLoading: false
        });
        localStorage.setItem("vendor_data", JSON.stringify(response.data));
        localStorage.setItem("truekhoj_Vendor", true);
        window.location.href = '/dashboard';
      }
    }.bind(this))
  }

  render() {
    return (
      <section className="e-login-section">
        <div className="container-fluid">
          <div className="row e-login-logo-wrap">
            <div className="col-lg-12">
              <img src={logo} alt="AliceBlue Tradeschool logo"/>
            </div>
          </div>
        </div>
        <div className="container e-login-widget">
          <div className="row mt-5 pt-5">
            <div className="offset-lg-2 col-lg-2  e-login-img">
              <img src={loginHero} alt="Login hero"/>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AdminLogin;
